// extracted by mini-css-extract-plugin
module.exports = {"Image":"GalleryLoader_Image__ruxOe","LoaderAnimation":"GalleryLoader_LoaderAnimation__3XURN"};